import RouteComponent from "@/components/RouteComponent.vue";

export default {
  path: "/admin",
  component: RouteComponent,
  meta: { requiresAuth: true, requiredRole: 1 },
  children: [
    {
      path: "login",
      name: "admin.login",
      redirect: { name: "auth.login" },
    },
    {
      path: "firms",
      component: RouteComponent,
      children: [
        {
          path: "",
          name: "admin.firms",
          component: () =>
            import(
              /* webpackChunkName: "admin-firms" */ "@/views/admin/AdminFirmsView.vue"
            ),
          props: true,
          meta: {
            title: "admin-firms",
            header: { show: true },
            navbar: { show: true },
            footer: { show: true },
          },
        },
        {
          path: ":firmId(\\d+)",
          name: "admin.firms.show",
          component: () =>
            import(
              /* webpackChunkName: "admin-firm" */ "@/views/admin/AdminFirmView.vue"
            ),
          props: true,
          meta: {
            title: "admin-firm",
            header: { show: true },
            navbar: { show: true },
            footer: { show: true },
          },
        },
        {
          path: ":firmId(\\d+)/enterprises/create",
          name: "admin.firms.enterprise.create",
          component: () =>
            import(
              /* webpackChunkName: "admin-enterprise-create" */ "@/views/enterprises/EnterpriseCreate.vue"
            ),
          props: true,
          meta: {
            title: "enterprise-create",
            header: { show: true },
            navbar: { show: true },
            footer: { show: true },
          },
        },
      ],
    },
    {
      path: "esg/upload",
      name: "admin.esg.upload",
      component: () =>
        import(
          /* webpackChunkName: "admin-esg-upload" */ "@/views/admin/AdminEsgUploadView.vue"
        ),
      meta: {
        title: "admin-esg-upload",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
    {
      path: "pricing-tiers",
      name: "admin.pricing-tiers",
      component: () =>
        import(
          /* webpackChunkName: "admin-pricing-tiers" */ "@/views/admin/AdminPricingTiersView.vue"
        ),
      meta: {
        title: "admin-pricing-tiers",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
    {
      path: "root-users",
      name: "admin.root-users",
      component: () =>
        import(
          /* webpackChunkName: "admin-root-users" */ "@/views/admin/AdminRootUsersView.vue"
        ),
      meta: {
        title: "admin-root-users",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
    {
      path: "async-migration-jobs",
      name: "admin.async-migration-jobs",
      component: () =>
        import(
          /* webpackChunkName: "admin-async-migration-jobs" */ "@/views/admin/AdminAsyncMigrationJobsView.vue"
        ),
      meta: {
        title: "admin-async-migration-jobs",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
  ],
};
